import { useState, type FC } from "react";

export const CopyButton: FC<{
  text: string;
  absolute?: boolean;
}> = ({ text, absolute = true }) => {
  const [copied, setCopied] = useState(false);
  return (
    <button
      className="vmx-btn vmx-btn-ghost vmx-btn-sm"
      style={{
        ...(absolute
          ? { position: "absolute", top: 6, right: 6 }
          : { flexShrink: 0 }),
        fontSize: "0.6875rem",
        color: copied ? "var(--vmx-success)" : "var(--vmx-gray-400)",
      }}
      onClick={async (e) => {
        e.stopPropagation();
        try {
          await navigator.clipboard.writeText(text);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch {
          // Clipboard API unavailable — silently ignore
        }
      }}
    >
      {copied ? "✓ Copied" : "⧉ Copy"}
    </button>
  );
};
